module.exports = __webpack_public_path__ + "static/img/HistoryGroupPic_1.png";